import { Fragment } from "react";
import { DATE_FORMATS } from "../../../../../constants";
import { groupExercisesByComplex } from "../../../../../utils/complex";
import {
  computeSectionPrefixes,
  groupExercisesBySection,
} from "../../../../../utils/prefix-calculator";
import { splitSections } from "../../../../../utils/section-types";
import MonthExercise from "../../../../dashboard/calendar/components/MonthExercise";
import WorkoutNoteBlock from "../EditMode/ExerciseEditor/WorkoutNoteBlock";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const SectionHeader = ({ section }) => (
  <div className="section-separator section-separator--readonly">
    <span className="section-separator__title">{section.name}</span>
  </div>
);

const Exercises = ({
  exercises,
  supersets,
  withWeight,
  fromMetric,
  units,
  round,
  expanded,
  date,
  intensityMeasure,
  isRiR,
  mobile = false,
  athlete,
  sections = [],
}) => {
  const groupedExercises = groupExercisesByComplex(exercises);

  // The workout note renders separately, above every exercise — pull it out
  // of `sections` so it never enters the separator-grouping logic.
  const { sections: normalSections, note } = splitSections(sections);

  // Section overlay: per-section letter reset + where each separator renders.
  const sectionPrefixes = computeSectionPrefixes(exercises, normalSections);
  const sectionGroups = groupExercisesBySection(exercises, normalSections);
  const sectionByFirstExerciseId = {};
  const emptySections = [];
  sectionGroups.forEach((group) => {
    if (!group.section) return;
    if (group.exercises.length) {
      sectionByFirstExerciseId[group.exercises[0]._id] = group.section;
    } else {
      emptySections.push(group.section);
    }
  });

  return (
    <div className={`exercises-frame${expanded ? " expanded" : ""}`}>
      <WorkoutNoteBlock note={note} editable={false} collapsible />
      {groupedExercises.map((exercise) => {
        if (!exercise) return null;
        return (
          <Fragment key={exercise._id}>
            {sectionByFirstExerciseId[exercise._id] && (
              <SectionHeader section={sectionByFirstExerciseId[exercise._id]} />
            )}
            <MonthExercise
              exercise={exercise}
              supersets={supersets}
              sectionPrefix={sectionPrefixes[exercise._id]}
              withWeight={withWeight}
              fromMetric={fromMetric}
              units={units}
              round={round}
              expanded={expanded}
              date={date.format(DATE_DAY_FORMAT)}
              intensityMeasure={intensityMeasure}
              isRiR={isRiR}
              mobile={mobile}
              showCopyButton={true}
              athlete={athlete}
              exercises={exercise.exercises}
            />
          </Fragment>
        );
      })}
      {emptySections.map((section) => (
        <SectionHeader key={section._id} section={section} />
      ))}
    </div>
  );
};

export default Exercises;
